export default __webpack_public_path__ + "static/stanleyknifemark-61ae82998938de65db0bafbadee12d98.png";